import { useSharedContext } from '@leverege/ui-plugin'
import { useMemo } from 'react'
import { DateTime } from 'luxon'
import { OperatingHours } from '@leverege/operating-hours'

import { getOpenHoursFromOperatingHours } from '../../../../util'

export default function useOccupancyData( opts ) {
  const { events } = opts
  const { items } = events

  const { operatingHours } = useSharedContext()

  const { data } = useMemo( () => {
    const openHours = getOpenHoursFromOperatingHours( operatingHours, false )
    const timezone = OperatingHours.getTimezone( operatingHours )

    const ret = openHours.reduce( ( prev, hour ) => {
      prev[hour] = {
        dog : 0,
        person : 0,
        dogEventCount : 0,
        personEventCount : 0,
      }

      return prev
    }, {} )

    items?.forEach( ( item ) => {

      const { time, data } = item
      const { resources } = data
      const dateTime = DateTime
        .fromISO( time )
        .setZone( timezone )
      const hour = dateTime.get( 'hour' )

      if ( ret[`${hour}`] ) {
        if ( data.data?.counts?.person != null ) {
          ret[`${hour}`].person += data.data.counts.person
          ret[`${hour}`].personEventCount += 1
        }
        
        if ( data.data?.counts?.dog != null ) {
          ret[`${hour}`].dog += data.data.counts.dog
          ret[`${hour}`].dogEventCount += 1
        }
        
        if ( !ret[`${hour}`].imgSrc && resources?.[0]?.path ) {
          ret[`${hour}`].imgSrc = resources[0].path
          ret[`${hour}`].imgDeviceId = resources[0].device.deviceId
        }
      }
    } )

    const d = Object.entries( ret ).map( ( [ hour, data ] ) => {
      return {
        hour,
        person :
          data.person > 0 ? Math.round( data.person / data.personEventCount ) : 0,
        dog : data.dog > 0 ? Math.round( data.dog / data.dogEventCount ) : 0,
        imgSrc : data.imgSrc,
        imgDeviceId : data.imgDeviceId
      }
    } )

    return {
      data : d,
    }
  }, [ items, operatingHours ] )

  const config = useMemo( () => {
    return {
      scale : {
        x : { type : 'point' },
        y : { type : 'linear' },
      },
      accessors : {
        person : {
          xAccessor : d => d.hour,
          yAccessor : d => d.person,
        },
        dog : {
          xAccessor : d => d.hour,
          yAccessor : d => d.dog,
        },
      },
      tickFormat : {
        x : ( value ) => {
          const int = parseInt( value )

          if ( int === 12 ) {
            return `${int}PM`
          }
          if ( int < 12 ) {
            return `${int}AM`
          }

          return `${int - 12}PM`
        },
        y : value => parseFloat( value )
        
      },
    }
  }, [] )

  return {
    data,
    config,
  }
}
